import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

// Dependend components
import { ViewComponent, PartsViewAppComponent } from './ui';
import { PartsViewComponent } from './parts-view.component';
import { SearchComponent } from './components/search/search.component';
import { IconComponent } from './components/icon/icon.component';
import { NavComponent } from './components/nav/nav.component';
import { SearchListComponent } from './components/search-list/search-list.component';
import { PartsComponent } from './components/parts/parts.component';

// Pipes
import { ArrayFilterPipe } from './pipes/array-filter.pipe';
import { BasketFilterPipe } from './pipes/basket-filter.pipe';
import { BasketCountPipe } from './pipes/basket-count.pipe';
import { SafePipe } from './pipes/safe.pipe';

// NgRx
import { dataReducer } from './store/reducer/data.reducer';
import { configReducer } from './store/reducer/config.reducer';
import { basketReducer } from './store/reducer/basket.reducer';
import { DataEffects } from './store/effects/data.effects';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [
    PartsComponent,
    SearchComponent,
    IconComponent,
    SearchListComponent,
    PartsViewAppComponent,
    PartsViewComponent,
    ArrayFilterPipe,
    BasketFilterPipe,
    NavComponent,
    ViewComponent,
    SafePipe,
    BasketCountPipe
  ],
  exports: [
    PartsComponent,
    SearchComponent,
    IconComponent,
    SearchListComponent,
    PartsViewAppComponent,
    PartsViewComponent,
    ArrayFilterPipe,
    BasketFilterPipe,
    NavComponent,
    ViewComponent,
    SafePipe,
    BasketCountPipe
  ],
  imports: [
    BrowserModule,
    StoreModule.forFeature('data', dataReducer),
    StoreModule.forFeature('config', configReducer),
    StoreModule.forFeature('basket', basketReducer),
    EffectsModule.forFeature([DataEffects]),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslateModule,
    SharedModule
  ],
  providers: [ArrayFilterPipe, BasketFilterPipe, BasketCountPipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SmartreportPartsviewLibraryModule {}
